import Menus from "../Menus"

const HelpTopicTarification = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
    { label: 'Tarification et frais', link: '/topics/paiement/tarification'},
  ]

  const multiMenus = [
    {title: null, filter: 'HelpTopicTarification'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus} desiredOrder={[48]}/>
}

export default HelpTopicTarification